// Firebase App (the core Firebase SDK) is always required and must be listed first
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { app } from "../../_db";

// Initialize services using the dynamic Firebase app configuration
const auth = getAuth(app);
const firestore = getFirestore(app);
const functions = getFunctions(app, "europe-west1");
// Initialize Firebase Storage - uses bucket location from Firebase project configuration
const storage = getStorage(app);

// Export variables
export { auth, firestore, functions, storage, ref, uploadBytes, getDownloadURL };
